import { useMutation, useQueryClient } from "react-query";
import { ITagValue } from "../../common/models/ITagValue";
import ManualEntryDataService from "../../services/manual-entry-data-service/ManualEntryDataService";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseMutationParameters } from "../BaseUseMutationParameters";
import { keys as tagHistoryKeys } from "../tag-history/Keys";
import { keys as tagManualEntryKeys } from "./Keys";

export type UseDeleteTagValueParameters = {
    groupID: number,
    convertToContractDay?: boolean,
} & BaseUseMutationParameters<string, ITagValue>;

export function useDeleteTagValue({
    groupID,
    convertToContractDay,
    onError,
    onSuccess
}: UseDeleteTagValueParameters) {
    const queryClient = useQueryClient();

    return useMutation<string, RestError, ITagValue>(
        (value) => {
            
            return ManualEntryDataService.deleteTagValue(
                groupID,
                value,
                convertToContractDay
            );
        },
        {
            onError: onError,
            onSuccess: onSuccess,
            onSettled: () => {
                queryClient.invalidateQueries(tagManualEntryKeys.tagManualEntries());
                queryClient.invalidateQueries(tagHistoryKeys.histories());
            }
        }
    );
}